/* Start Slider Script */
var hSlideIndicator = true;
$(document).on('click touch', '*[data-h-slide]', function () {
    if(hSlideIndicator == true){
/*         // hSlideIndicator = false; */
        var target = $(this).attr('data-h-slide');
        $(this).addClass('active').siblings('*[data-h-slide]').removeClass('active');
        $('#' + target).addClass('active').siblings('.h-slide__item').removeClass('active visible');
        setTimeout(() => {
            $('#' + target).addClass('visible');
        }, 0.001);
        setTimeout(() => {
            hSlideIndicator = true;
        }, 1000);
    }
});

function hSliderSimpleEqHeight() {
    var res = resolutionCheck();
    if (res < 120) {
        $('.h-slide__title').css('height', 'auto');
        var maxH = 0;
        $('.h-slide__title').each(function () {
            maxH = $(this).outerHeight() > maxH ? $(this).outerHeight() : maxH;
        });
        $('.h-slide__title').outerHeight(maxH);
    }
}

$(window).on('load ', function(){
    if ($('.h-slide__title').length) {
        hSliderSimpleEqHeight();
    }
});
$(window).on('resize orientationchange', function(){
        hSliderSimpleEqHeight();
});

/* End Slider Script */




// // Disable window scroll at needed point
// if($('.no-touchevents').length){

//     /* STOP PAGE SCROLL AT .scrollable-area */
//     function windowStopScrollPoint() {
//         if (!$('.h-slide__item:last-child').hasClass('active')) {
//             let res = resolutionCheck(),
//                 areaOffset = $('.scrollable-area').offset().top,
//                 wS = $(window).scrollTop();
//             if (res > 76 && wS >= areaOffset) {
//                 $(window).scrollTop(areaOffset);

//             }
//             else {
//             }
//         }

//     }
//     $(document).ready(function () {
//         if ($('.scrollable-area').length) {
//             $(window).on('scroll', function (e) {
//                 windowStopScrollPoint();
//             });
//         }
//     });
//     /*********************/

//     let iScrollDirection;
//     $('.scrollable-area').bind('mousewheel DOMMouseScroll', function (e) {
//         if (e.originalEvent.wheelDelta / 120 <= 0) {
//             iScrollDirection = 1;
//              // console.log('scrolling down !');
//             if (!$('.h-slide__item:last-child').hasClass('js-last-active')) {
//                 let res = resolutionCheck(),
//                     areaOffset = $(this).offset().top,
//                     wS = $(window).scrollTop();
//                 // if (res > 76 && wS >= areaOffset) {
//                 if (res > 76 && wS >= areaOffset) { 
                    
//                     //  disable page scroll

//                     let scrollTo = null;
//                     if (e.type == 'mousewheel') {
//                         scrollTo = (e.originalEvent.wheelDelta * -1);
//                     }
//                     else if (e.type == 'DOMMouseScroll') {
//                         scrollTo = 40 * e.originalEvent.detail;
//                     }
//                     if (scrollTo) {
//                         e.preventDefault();
//                         $(this).scrollTop(scrollTo + $(this).scrollTop());
//                     }

//                     // end of disable page scroll
//                 }
//             }
//         }
//         else {
//             iScrollDirection = 0;
//         }
//     });
//     /*****/

//     // Switch slides if page scrolls down (iScrollDirection)
//     function switchHSlide(e) {
//         if (!$('.h-slide__item:last-child').hasClass('active')) {
//             let res = resolutionCheck(),
//                 // areaOffset = $('.scrollable-area').offset().top,
//                 wS = $(window).scrollTop();
//             // if (res > 76 && wS >= areaOffset && iScrollDirection != 0) {
//             if (res > 76 && iScrollDirection != 0) {
//                 $('.h-slide__bullet:not(:last-child).active, .h-slide__item:not(:last-child).active')
//                 .removeClass('active')
//                 .next()
//                 .addClass('active');
//                 setTimeout(() => {
//                     $('.h-slide__item.active').addClass('visible');
//                 }, 0.001);
//                 $('.h-slide__item:last-child').removeClass('js-last-active');
//             }

//         }
//         else {
//             setTimeout(() => {
//                 $('.h-slide__item:last-child').addClass('js-last-active');
//             }, 100);
//         }
//     }
//     /*****/

//     // Set time out for slides switch availability
//     function throttle(fn, wait) {
//         var time = Date.now();
//         return function () {
//             if ((time + wait - Date.now()) < 0) {
//                 fn();
//                 time = Date.now();
//             }
//         }
//     }
//     $('.js-h-slide-scrollbar').bind('mousewheel DOMMouseScroll', throttle(switchHSlide, 700));
//     /*******/



// }





